import { defineStore } from "pinia";
import { useGetData } from "~/composables/useGetData";

export const useMerciArrivatiStore = defineStore("merciArrivatiStore", {
  state: () => ({
    merciArrivati: [],
    caricandoMerciArrivati: false,
    errorMessage: ""
  }),
  actions: {
    async getMerciArrivatiOdoo() {
      const { data, getData, loading, messageError } = useGetData();
      this.caricandoMerciArrivati = true;
      await getData("/api/merci/arrivati");
      if (!messageError.value) {
        this.merciArrivati = data.value;
        this.caricandoMerciArrivati = loading.value;
      } else {
        this.errorMessage = messageError;
      }
    }
  }
});
